import { C } from "../reporting/reportingStyles";

/** Styles shared by the Pages screens, in the same vocabulary as the banner screens. */

export const inputStyle = {
  width: "100%",
  padding: "9px 12px",
  borderRadius: 8,
  fontSize: 13,
  border: `1px solid ${C.border}`,
  background: C.white,
  color: C.text,
  outline: "none",
  fontFamily: "inherit",
};

export const labelStyle = { display: "block", fontSize: 12, fontWeight: 600, color: C.textMed, marginBottom: 6 };
export const hintStyle = { fontSize: 11, color: C.textLight, marginTop: 4, lineHeight: 1.5 };
export const errorText = { fontSize: 11, color: "#c0392b", marginTop: 4 };

export const buttonStyle = {
  padding: "9px 16px",
  borderRadius: 10,
  fontSize: 13,
  fontWeight: 700,
  border: "none",
  cursor: "pointer",
  background: `linear-gradient(135deg, ${C.coral}, #00bfa5)`,
  color: C.white,
  boxShadow: "0 4px 12px rgba(0, 150, 137,0.25)",
  whiteSpace: "nowrap",
};
export const btnSecondary = { ...buttonStyle, background: C.white, color: C.textMed, border: `1px solid ${C.border}`, boxShadow: "none" };
export const btnDanger = { ...buttonStyle, background: "#dc2626", boxShadow: "none" };
export const linkBtn = { padding: "4px 8px", border: "none", background: "none", color: C.coral, fontSize: 12, fontWeight: 600, cursor: "pointer" };

export const iconBtn = {
  border: `1px solid ${C.border}`,
  background: C.white,
  borderRadius: 6,
  width: 28,
  height: 28,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 0,
  cursor: "pointer",
  color: C.textMed,
  flexShrink: 0,
};

export const chip = (active) => ({
  padding: "3px 10px",
  borderRadius: 999,
  fontSize: 11,
  fontWeight: 700,
  border: `1px solid ${active ? C.coral : C.border}`,
  background: active ? C.coralLight : C.white,
  color: active ? C.coralDark : C.textMed,
  cursor: "pointer",
});

export const notice = (tone = "warning") => {
  const tones = {
    warning: { background: C.orangeLight, color: "#b45309" },
    info: { background: C.blueLight, color: C.blue },
    error: { background: "#fef2f2", color: "#b91c1c" },
  };
  return { padding: "12px 16px", borderRadius: 12, fontSize: 13, fontWeight: 600, marginBottom: 16, ...tones[tone] };
};
